export default [
	"が",
	"を",
	"に",
	"へ",
	"と",
	"から",
	"より",
	"まで",
	"で",
	"か",
	"の",
	"や",
	"やら",
	"だ",
	"なり",
	"わ",
	"とも",
	"かしら",
	"かな",
	"かい",
	"っけ",
	"さ",
	"よ",
	"ね",
	"ばかり",
	"ばっかり",
	"ばっか",
	"ばかし",
	"だけ",
	"きり",
	"っきり",
	"ほど",
	"くらい",
	"ぐらい",
	"ころ",
	"ごろ",
	"など",
	"は",
	"も",
	"こそ",
	"でも",
	"しか",
	"さえ",
	"ば",
	"て",
	"のに",
	"ので",
	"ところ",
	"けれども",
	"けれど",
	"くせ",
	"もの",
	"もん",
	"ものか",
	"もんか",
	"な",
	"なあ",
	"なんか",
	"なんて",
	"って",
	"し",
	"ずつ",
	"すら",
	"ともに",
	"ぜ",
	"ぞ",
	"じゃん",
	"ながら",
	"たり",
	"だり",
	"つつ",
	"まま",
	"ものの",
	"つまり",
	"しかし",
	"よって",
	"に関する",
	"に関し",
	"について",
	"における",
	"において",
	"関",
	"する",
	"関し",
	"ついて",
	"おえる",
	"おける",
	"という",
	"といっ",
	"た",
	"に対する",
	"対",
	"に対して",
	"対して",
	"にかけ",
	"による",
	"により",
	"によって",
	"および",
	"これ",
	"それ",
	"あれ",
	"どれ",
	"こちら",
	"こっち",
	"そちら",
	"そっち",
	"あちら",
	"あっち",
	"どちら",
	"どっち",
	"ここ",
	"そこ",
	"あそこ",
	"どこ",
	"こう",
	"そう",
	"ああ",
	"どう",
	"こんな",
	"そんな",
	"あんな",
	"どんな",
	"この",
	"よう",
	"その",
	"あの",
	"ど",
	"こうやって",
	"そうやって",
	"ああやって",
	"やっ",
	"どの",
	"こっ",
	"そっから",
	"どっ",
	"さま",
	"あちらさま",
	"どちらさま",
	"そちらさま",
	"こんだけ",
	"そんだけ",
	"あんだけ",
	"どん",
	"なに",
	"なん",
	"何",
	"どいつ",
	"どなた",
	"だれ",
	"誰",
	"いつ",
	"なぜ",
	"どうして",
	"どれくらい",
	"どれぐらい",
	"位",
	"いくら",
	"いくつ",
	"一",
	"二",
	"三",
	"四",
	"五",
	"六",
	"七",
	"八",
	"九",
	"十",
	"百",
	"千",
	"万",
	"億",
	"兆",
	"ひとつ",
	"ふたつ",
	"みっつ",
	"よっつ",
	"いつつ",
	"むっつ",
	"ななつ",
	"やっつ",
	"ここのつ",
	"とお",
	"つ",
	"こ",
	"コ",
	"個",
	"人",
	"ひき",
	"匹",
	"まい",
	"枚",
	"さつ",
	"冊",
	"杯",
	"回",
	"キロ",
	"グラム",
	"適量",
	"少々",
	"大匙",
	"大さじ",
	"小匙",
	"小さじ",
	"g",
	"cc",
	"ml",
	"l",
	"kg",
	"番目",
	"め",
	"週",
	"時間",
	"週間",
	"時",
	"分",
	"秒",
	"か月",
	"カ月",
	"ヶ月",
	"部分",
	"一部",
	"ほか",
	"他",
	"それぞれ",
	"まっ",
	"たく",
	"全く",
	"ぜんぶ",
	"全部",
	"すべて",
	"全",
	"すごく",
	"最高",
	"最悪",
	"可能",
	"良い",
	"良く",
	"良さ",
	"いい",
	"よい",
	"悪い",
	"悪く",
	"悪さ",
	"大きな",
	"おおき",
	"小さ",
	"ちいさ",
	"だめ",
	"ダメ",
	"駄目",
	"ただ",
	"ちょっと",
	"すこし",
	"少し",
	"なか",
	"たくさん",
	"よく",
	"たまに",
	"ときどき",
	"時々",
	"いつも",
	"およそ",
	"やく",
	"だい",
	"たい",
	"約",
	"程",
	"大体",
	"また",
	"もう",
	"とて",
	"おそらく",
	"たぶん",
	"恐らく",
	"多分",
	"のみ",
	"多少",
	"本当",
	"ほんとう",
	"まじ",
	"マジ",
	"勿論",
	"もちろん",
	"やっと",
	"しっかり",
	"さっき",
	"ほんと",
	"ホント",
	"きっと",
	"かならず",
	"必ず",
	"絶対",
	"ぜっ",
	"ゼッタイ",
	"にかく",
	"やっぱり",
	"やっぱ",
	"たっ",
	"はっきり",
	"すでに",
	"なる",
	"いっしょ",
	"緒",
	"だいじょうぶ",
	"ダイジョウブ",
	"大丈夫",
	"年",
	"月",
	"日",
	"今日",
	"明日",
	"明後",
	"昨日",
	"一昨日",
	"きょう",
	"あす",
	"あし",
	"あさっ",
	"き",
	"のう",
	"おととい",
	"今年",
	"来年",
	"去年",
	"ことし",
	"らいねん",
	"きょねん",
	"わたし",
	"わたくし",
	"あたし",
	"私",
	"あたくし",
	"うち",
	"うちら",
	"おら",
	"おいら",
	"わたしら",
	"たち",
	"わたしど",
	"われら",
	"われわ",
	"れ",
	"私ら",
	"私達",
	"達",
	"私共",
	"我ら",
	"我々",
	"おれ",
	"俺",
	"オレ",
	"おれら",
	"ぼく",
	"ボクら",
	"僕",
	"じぶん",
	"俺ら",
	"僕ら",
	"僕達",
	"自分",
	"俺達",
	"ボク",
	"あなた",
	"貴方",
	"貴女",
	"貴男",
	"君",
	"きみ",
	"おまえ",
	"お",
	"前",
	"あんた",
	"お宅",
	"てめえ",
	"貴殿",
	"彼",
	"彼ら",
	"彼女",
	"ら",
	"こいつ",
	"そいつ",
	"あいつ",
	"アイツ",
	"これら",
	"それら",
	"あれら",
	"あいつら",
	"ども",
	"みな",
	"みなさま",
	"おのおの",
	"共",
	"みんな",
	"皆様",
	"各々",
	"皆",
	"皆さま",
	"方",
	"当方",
	"自身",
	"さん",
	"様",
	"殿",
	"ちゃん",
	"くん",
	"こと",
	"事",
	"物",
	"コト",
	"やつ",
	"ヤツ",
	"奴",
	"まえ",
	"あと",
	"うえ",
	"後",
	"上",
	"下",
	"中",
	"先",
	"さらに",
	"更",
	"とく",
	"特に",
	"ほとんど",
	"再び",
	"ふたたび",
	"ほぼ",
	"そのまま",
	"すぐ",
	"あまり",
	"相当",
	"しばしば",
	"わずか",
	"僅か",
	"比較",
	"的",
	"まだ",
	"かなり",
	"つい",
	"まず",
	"やが",
	"やや",
	"つねに",
	"常",
	"ひきつづき",
	"引き続き",
	"きわめて",
	"極めて",
	"ごく",
	"別",
	"べつ",
	"はり",
	"必ずし",
	"かならずしも",
	"むしろ",
	"がい",
	"まも",
	"なく",
	"あら",
	"ためて",
	"けっし",
	"おも",
	"互い",
	"間",
	"改めて",
	"決し",
	"主",
	"主として",
	"もっと",
	"とりわけ",
	"あく",
	"おおむね",
	"おおい",
	"概ね",
	"大い",
	"そうし",
	"それほど",
	"ちょうど",
	"とえ",
	"まさに",
	"なんと",
	"とか",
	"あえて",
	"まる",
	"おおよそ",
	"ます",
	"ぜんぜん",
	"全然",
	"じゃ",
	"ません",
	"です",
	"あり",
	"ませ",
	"ん",
	"ない",
	"しませ",
	"なら",
	"ある",
	"ありませ",
	"いる",
	"い",
	"いませ",
	"できる",
	"でき",
	"れる",
	"られる",
	"せる",
	"させる",
	"思わ",
	"考え",
	"られ",
	"おっしゃい",
	"述べ",
	"言わ",
	"話",
	"なられ",
	"お思い",
	"らしい",
	"らしく",
	"でしょ",
	"う",
	"だろ",
	"ご",
	"御",
	"ハイ",
	"はい",
	"いいえ",
	"うん",
	"うーん",
	"ええ",
	"よし",
	"いや",
	"まあ",
	"おい",
	"ねえ",
	"どうぞ",
	"ほら",
	"おお",
	"あー",
	"さあ",
	"まし",
	"でし",
	"だっ",
	"なかっ",
	"しまし",
	"なっ",
	"あっ",
	"いた",
	"せ",
	"させ",
	"ますか",
	"み",
	"みませ",
	"ましょ",
	"でみ",
	"でみませ",
	"なられる",
	"なろ",
];
